import { render, staticRenderFns } from "./account_reg.vue?vue&type=template&id=01b208c0&scoped=true"
import script from "./account_reg.vue?vue&type=script&lang=js"
export * from "./account_reg.vue?vue&type=script&lang=js"
import style0 from "./account_reg.vue?vue&type=style&index=0&id=01b208c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b208c0",
  null
  
)

export default component.exports